var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3556_6098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83336 11.5138L3.82288 12.1769L4.48605 14.1665C4.75243 14.9656 5.91226 14.8696 6.04364 14.0376L6.38232 11.8926L9.22616 9.6175L11.6064 13.7289C11.9273 14.2831 12.7356 14.2583 13.022 13.6856L13.3563 13.0169C13.4437 12.8421 13.4645 12.6415 13.4147 12.4525L12.07 7.34243L14.4334 3.7973C15.4088 2.33419 13.6656 0.591004 12.2025 1.56641L8.65739 3.92984L3.54733 2.58509C3.35834 2.53535 3.15771 2.55612 2.98291 2.64352L2.31425 2.97785C1.74148 3.26424 1.71675 4.07255 2.27096 4.3934L6.38232 6.77367L4.10726 9.6175L1.96227 9.95618C1.1302 10.0876 1.0342 11.2474 1.83336 11.5138Z",
    stroke: "#03182F",
    strokeWidth: 1.28338,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3556_6098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.1817cbb54ce2bb122fea177276a63f66.svg";
export { ForwardRef as ReactComponent };